export const MonkInspectionStatus = Object.freeze({
  Done: 'DONE',
  Error: 'ERROR',
  NotStarted: 'NOT_STARTED',
});
